import { render } from "./business-stage-input.vue?vue&type=template&id=0bb414df&ts=true"
import script from "./business-stage-input.vue?vue&type=script&lang=ts"
export * from "./business-stage-input.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__